import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";



import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function FuelShipType(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, screen, updateParent,reset, type } = props;
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const [FuelShipTypeData, setFuelShipTypeData] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const fetchEquipNameData = async (event) => {
        //
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/FuelShipType/${searchStr}`;

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    //let obj = { "axContractId": "All" };
                  
                    let data = res.data;
                    let result = data?.map((a, i) => {
                        return { id: a?.id, name: a?.title };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setFuelShipTypeData(result);
                } else {
                    //ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const handleChange = (event, newValue) => {
        props.onChange(newValue);
        const filteredFuelShipType = {
            ...formObj,
            FqtShipType: newValue
        };
        setFormObj(filteredFuelShipType);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                FqtShipType: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        //
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                FqtShipType: filtervalue.FqtShipType
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.FqtShipType);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.FqtShipType);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj.FqtShipType || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={FuelShipTypeData}
                getOptionLabel={(option) => option.name}
 
                onChange={(event, newValue) => handleChange(event, newValue)}
                inputValue={filteredString}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Ship Type"
                        placeholder=""
                        onChange={fetchEquipNameData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

